export class LoggedUser {
    displayName!: string;
    user_roles!: ROLES[];
    idToken!: string;
    uuidPassenger?: string;
    displayNameImp?: string;
}

export abstract class Role {

    static get_Role(myRole: string): ROLES | undefined {
        const match = Object.entries(ROLES).find(([key, value]) => myRole.indexOf(value) > -1);
        return match ? match[1] : undefined
    }
}

export enum ROLES {
    PASSEGGERO = "PASSENGER",
    OPERATORE = "OPERATOR",
    ADMIN = "ADMIN"
}